import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle, linkText, buttonStyle } from '../../../helpers/getEmailStyles';

class ConfirmEmail extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  };

  render() {
    const { content: { token, email, name, logo, siteName } } = this.props;
    let verificationURL = url + `/user/verification?confirm=${token}&email=${email}`;
    let firstName = name.charAt(0).toUpperCase() + name.slice(1);

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
        <Body textStyle={textStyle}>
          <div>
            Hola {firstName},
          </div>
          <EmptySpace height={20} />
          <div>
            Bienvenido a {siteName}! para empezar necesitas confirmar tu dirección de correo electrónico.
          </div>
          <EmptySpace height={40} />
          <div>
            <a style={buttonStyle} href={verificationURL}>Confirmar tu Correo electrónico</a>
          </div>
          <EmptySpace height={30} />
          <EmailSignature siteName={siteName} />
        </Body>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default ConfirmEmail;